const filterConfig = {
  type: 'object',
  properties: {      
      search: {
          type: 'string',
      },
      attribute_id: {
          type: "number",
      }
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;